export const oldApiEnvironmentProd = {
  production: true,
  api: '',
  applicationKey: '',
  applicationVersion: ''
};
